module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6JEuNa/tc-custom/9781685505714.jpg?1723405008989",
      "alt": "This image is the cover for the book Greater Love Box Set"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Greater Love Box Set\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("James Trevalyan comes from a long line of men who served the Crown with their gift of a voice with compelling power, and kept that tradition going while he loved and lived with Jeremy Waters. When Jeremy died in James's arms, he resolved to live without love. His family keeps him connected to the world. And then came Tanner, a clever, handsome agent who joins him in an ongoing undercover mission."), _c('br'), _c('br'), _vm._v("J Tanner is a valued member of National Security 3 and in love with his superior, James Trevalyan. He hides his love, certain James could not return it. But after completing a mission that almost costs him his life, he’s asked by James to help unravel the mystery of James’s beloved sister’s disappearance. As a colleague, of course he agrees."), _c('br'), _c('br'), _vm._v("Will these two ever realize they’re meant for each other?"), _c('br'), _c('br'), _vm._v("This box set contains the two books "), _c('i', [_vm._v("Greater Love Hath No Man")]), _vm._v(" and "), _c('i', [_vm._v("Darling James")]), _vm._v(".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tinnean\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0